export const actions = {
  FRANJAS_HORARIOS_LOAD_REQUESTED: 'FRANJAS_HORARIOS_LOAD_REQUESTED',
  FRANJAS_HORARIOS_LOAD_SUCCEEDED: 'FRANJAS_HORARIOS_LOAD_SUCCEEDED',
  FRANJAS_HORARIOS_LOAD_FILED: 'FRANJAS_HORARIOS_LOAD_FILED',

  FRANJAS_HORARIOS_EDITAR_LOAD_REQUESTED: 'FRANJAS_HORARIOS_EDITAR_LOAD_REQUESTED',
  FRANJAS_HORARIOS_EDITAR_LOAD_SUCCEEDED: 'FRANJAS_HORARIOS_EDITAR_LOAD_SUCCEEDED',
  FRANJAS_HORARIOS_EDITAR_LOAD_FILED: 'FRANJAS_HORARIOS_EDITAR_LOAD_FILED',

  FRANJA_HORARIO_EDITAR_DELETE_REQUESTED: 'FRANJA_HORARIO_EDITAR_DELETE_REQUESTED',
  FRANJA_HORARIO_EDITAR_DELETE_SUCCEEDED: 'FRANJA_HORARIO_EDITAR_DELETE_SUCCEEDED',
  FRANJA_HORARIO_EDITAR_DELETE_FILED: 'FRANJA_HORARIO_EDITAR_DELETE_FILED',

  FRANJA_HORARIO_INSERT_REQUESTED: 'FRANJA_HORARIO_INSERT_REQUESTED',
  FRANJA_HORARIO_INSERT_SUCCEEDED: 'FRANJA_HORARIO_INSERT_SUCCEEDED',
  FRANJA_HORARIO_INSERT_FILED: 'FRANJA_HORARIO_INSERT_FILED',

  FRANJA_HORARIO_UPDATE_REQUESTED: 'FRANJA_HORARIO_UPDATE_REQUESTED',
  FRANJA_HORARIO_UPDATE_SUCCEEDED: 'FRANJA_HORARIO_UPDATE_SUCCEEDED',
  FRANJA_HORARIO_UPDATE_FILED: 'FRANJA_HORARIO_UPDATE_FILED',

  FRANJA_HORARIO_EDITAR_UPDATE_REQUESTED: 'FRANJA_HORARIO_EDITAR_UPDATE_REQUESTED',
  FRANJA_HORARIO_EDITAR_UPDATE_SUCCEEDED: 'FRANJA_HORARIO_EDITAR_UPDATE_SUCCEEDED',
  FRANJA_HORARIO_EDITAR_UPDATE_FILED: 'FRANJA_HORARIO_EDITAR_UPDATE_FILED',

  FRANJA_HORARIO_DELETE_REQUESTED: 'FRANJA_HORARIO_DELETE_REQUESTED',
  FRANJA_HORARIO_DELETE_SUCCEEDED: 'FRANJA_HORARIO_DELETE_SUCCEEDED',
  FRANJA_HORARIO_DELETE_FILED: 'FRANJA_HORARIO_DELETE_FILED',

  FECHA_HORARIO_INSERT_REQUESTED: 'FECHA_HORARIO_INSERT_REQUESTED',
  FECHA_HORARIO_INSERT_SUCCEEDED: 'FECHA_HORARIO_INSERT_SUCCEEDED',
  FECHA_HORARIO_INSERT_FILED: 'FECHA_HORARIO_INSERT_FILED',

  UBICACIONES_HORARIOS_LOAD_REQUESTED: 'UBICACIONES_HORARIOS_LOAD_REQUESTED',
  UBICACIONES_HORARIOS_LOAD_SUCCEEDED: 'UBICACIONES_HORARIOS_LOAD_SUCCEEDED',
  UBICACIONES_HORARIOS_LOAD_FILED: 'UBICACIONES_HORARIOS_LOAD_FILED',

  FRANJA_HORARIO_BY_ID_LOAD_REQUESTED: 'FRANJA_HORARIO_BY_ID_LOAD_REQUESTED',
  FRANJA_HORARIO_BY_ID_LOAD_SUCCEEDED: 'FRANJA_HORARIO_BY_ID_LOAD_SUCCEEDED',
  FRANJA_HORARIO_BY_ID_LOAD_FILED: 'FRANJA_HORARIO_BY_ID_LOAD_FILED',

  UBICACIONES_LOAD_REQUESTED: 'UBICACIONES_LOAD_REQUESTED',
  UBICACIONES_LOAD_SUCCEEDED: 'UBICACIONES_LOAD_SUCCEEDED',
  UBICACIONES_LOAD_FILED: 'UBICACIONES_LOAD_FILED',

  UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_REQUESTED:
    'UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_REQUESTED',
  UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_SUCCEEDED:
    'UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_SUCCEEDED',
  UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_FILED: 'UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_FILED',

  UBICACIONES_MRW_LOAD_REQUESTED: 'UBICACIONES_MRW_LOAD_REQUESTED',
  UBICACIONES_MRW_LOAD_SUCCEEDED: 'UBICACIONES_MRW_LOAD_SUCCEEDED',
  UBICACIONES_MRW_LOAD_FILED: 'UBICACIONES_MRW_LOAD_FILED',
}

export const getFranjasHorariosAction = dispatch => {
  dispatch({
    type: actions.FRANJAS_HORARIOS_LOAD_REQUESTED,
  })
}

export const getFranjasHorariosEditarAction = (dispatch, limitarHorarioId) => {
  dispatch({
    type: actions.FRANJAS_HORARIOS_EDITAR_LOAD_REQUESTED,
    payload: limitarHorarioId,
  })
}

export const deleteFranjasHorarioEditarAction = (dispatch, id) => {
  dispatch({
    type: actions.FRANJA_HORARIO_EDITAR_DELETE_REQUESTED,
    payload: id,
  })
}

export const onSubmitFranjaHorarioAction = (dispatch, franjaHorarioForm) => {
  dispatch({
    type: actions.FRANJA_HORARIO_INSERT_REQUESTED,
    payload: franjaHorarioForm,
  })
}

export const onSubmitFranjaHorarioUpdateAction = (dispatch, franjaHorarioForm) => {
  dispatch({
    type: actions.FRANJA_HORARIO_UPDATE_REQUESTED,
    payload: franjaHorarioForm,
  })
}

export const onSubmitFranjaHorarioEditarUpdateAction = (dispatch, franjaHorarioForm) => {
  dispatch({
    type: actions.FRANJA_HORARIO_EDITAR_UPDATE_REQUESTED,
    payload: franjaHorarioForm,
  })
}

export const deleteFranjasHorarioAction = (dispatch, id) => {
  dispatch({
    type: actions.FRANJA_HORARIO_DELETE_REQUESTED,
    payload: id,
  })
}

export const onSubmitFechaHorarioAction = (dispatch, fechaHorarioForm) => {
  dispatch({
    type: actions.FECHA_HORARIO_INSERT_REQUESTED,
    payload: fechaHorarioForm,
  })
}

export const getUbicacionesHorariosAction = (dispatch, fecha) => {
  dispatch({
    type: actions.UBICACIONES_HORARIOS_LOAD_REQUESTED,
    payload: fecha,
  })
}

export const getFranjaHorarioAction = (dispatch, id) => {
  dispatch({
    type: actions.FRANJA_HORARIO_BY_ID_LOAD_REQUESTED,
    payload: id,
  })
}

export const getUbicacionesAction = dispatch => {
  dispatch({
    type: actions.UBICACIONES_LOAD_REQUESTED,
  })
}

export const getUbicacionesHorariosNoEspecialAction = dispatch => {
  dispatch({
    type: actions.UBICACIONES_HORARIOS_NO_ESPECIAL_LOAD_REQUESTED,
  })
}

export const getUbicacionesHorarioEntregaMRWAction = dispatch => {
  dispatch({
    type: actions.UBICACIONES_MRW_LOAD_REQUESTED,
  })
}
